import { Anchor } from '@phosphor-icons/react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer 
            className="py-12 bg-background-surface border-t border-border-subtle"
            data-testid="footer"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                    {/* Logo & Company */}
                    <div className="flex items-center gap-3">
                        <img 
                            src="https://customer-assets.emergentagent.com/job_eng-software-hub/artifacts/3icn5ytz_Spindrift%20Engineering%20Software.png"
                            alt="Spindrift Engineering"
                            className="h-8 w-auto"
                        />
                        <span className="text-text-secondary text-sm">
                            Spindrift Engineering Limited
                        </span>
                    </div>

                    {/* Links */}
                    <div className="flex items-center gap-6 text-sm">
                        <a 
                            href="#about" 
                            className="text-text-muted hover:text-text-primary transition-colors"
                            data-testid="footer-about-link"
                        >
                            About
                        </a>
                        <a 
                            href="#software" 
                            className="text-text-muted hover:text-text-primary transition-colors"
                            data-testid="footer-software-link"
                        >
                            Software
                        </a>
                        <a 
                            href="#contact" 
                            className="text-text-muted hover:text-text-primary transition-colors"
                            data-testid="footer-contact-link"
                        >
                            Contact
                        </a>
                    </div>

                    {/* Copyright */}
                    <div className="text-text-muted text-xs">
                        © {currentYear} Spindrift Engineering Limited. SC715585
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
